import { Show, SignIn } from '@clerk/react';
import { OrganizationGuard } from '../components/OrganizationGuard';
import { type FC, type PropsWithChildren } from 'react';

export const LoggedInGuard: FC<PropsWithChildren> = (props) => {
  return (
    <>
      <Show when="signed-in">
        <OrganizationGuard>{props.children}</OrganizationGuard>
      </Show>
      <Show when="signed-out">
        <SignInPage />
      </Show>
    </>
  );
};

const SignInPage: FC = () => (
  <div
    style={{
      margin: '1rem',
      display: 'flex',
      minHeight: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <SignIn
      // Makes the phone number input appear by default instead of the email input
      initialValues={{
        phoneNumber: '+',
      }}
      appearance={{
        elements: {
          // Hide the "sign up" UI
          footerAction: {
            display: 'none',
          },
        },
      }}
    />
  </div>
);
